import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByTypeAndUnit } from '../../';
import { HorizontalUsageChart } from './';
import { useDashboardCardSetUsageChart, useRouterStore, useUiUnitTypeValue } from '../../../hooks';
import { UnitTypeValues, getDashboardGraphTitleByUnitType } from '../../../middleware';
import { tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const CardSetUsage: React.FC = observer(() => {
    const unitType = useUiUnitTypeValue() || UnitTypeValues.DATA;
    const subTitle = getDashboardGraphTitleByUnitType(unitType || '');
    const title = `${tP('Top Card Sets')} ${subTitle}`;
    const apiTypeId = `GET_USAGE_CARD_SETS_LIST`;
    const data = useDashboardCardSetUsageChart(apiTypeId, unitType);
    const routerStore = useRouterStore();
    const goToCardList = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        event.preventDefault();
        routerStore.goTo('CardSetsList');
    };

    const titleLink = (): JSX.Element => (
        <a onClick={goToCardList} href={`/card_sets`}>
            {title}
        </a>
    );

    const goToCardSet = (id: string): void => {
        routerStore.goTo('CardSet', { params: { id } });
    };

    return (
        <Catcher>
            <LoadingApiByTypeAndUnit apiTypeId={apiTypeId} unitType={unitType} />
            <div className={Styles.chart}>
                <HorizontalUsageChart
                    sourceData={data}
                    title={title}
                    titleLink={titleLink()}
                    unitType={unitType}
                    onSelectRow={goToCardSet}
                />
            </div>
        </Catcher>
    );
});
